<template>
<div class="main-content">
    <index-header></index-header>
    <div class="body-wrap no-login">
        <!---->
        <div class="point-exchange-wrap" v-if="voucherList.length">
            <div class="type-wrap">
                <div class="content">
                    <div class="text-content type-name">
                        <span>积分换代金券</span>
                    </div>
                    <div class="view-content"></div>
                    <div class="text-content type-sub">
                        <span>代金券在手，省钱有道</span>
                    </div>
                </div>
                <div class="type-sub" @click="goVoucher()">更多<span class="iconfont type-sub">&#xe650;</span></div>
            </div>
            <div class="list-wrap">
                <index-voucher-item class="list-wrap-item" v-for="(item,index) in voucherList" :item="item" :key="index"></index-voucher-item>
            </div>
        </div>
        <div class="point-exchange-wrap" v-if="goodsList.length">
            <div class="type-wrap">
                <div class="content">
                    <div class="text-content type-name">
                        <span>积分换好物</span>
                    </div>
                    <div class="view-content"></div>
                    <div class="text-content type-sub">
                        <span>积累积分，兑换好物</span>
                    </div>
                </div>
                <div class="type-sub" @click="goProd()">更多<span class="iconfont type-sub">&#xe650;</span></div>
            </div>
            <div class="list-wrap">
                <div class="goods-list double-column">
                    <index-prod-item class="goods-item" v-for="(item,index) in goodsList" :item="item" :key="index"></index-prod-item>
                </div>
            </div>
        </div>
        <empty-record  v-if="voucherList.length==0 && goodsList.length == 0"></empty-record>
    </div>

</div>
</template>

<script>
    import EmptyRecord from '../../../components/EmptyRecord'
import IndexHeader from './IndexHeader'
import IndexProdItem from './IndexProdItem'
import IndexVoucherItem from './IndexVoucherItem'
import { getPointshop } from '../../../api/homePointsgoods'
export default {
  name: 'index',
  data () {
    return {
      goodsList: [],
      voucherList: []
    }
  },
  components: {
      EmptyRecord,
    IndexHeader,
    IndexProdItem,
    IndexVoucherItem
  },
  created: function () {
    getPointshop().then(res => {
        let recommend_voucher=res.result.recommend_voucher
        if(recommend_voucher){
            this.voucherList=recommend_voucher
        }
        let recommend_pointsprod=res.result.recommend_pointsprod
        if(recommend_pointsprod){
            this.goodsList=recommend_pointsprod
        }
    })
  },
  methods: {
    goVoucher () {
      this.$router.push({ name: 'HomePointVoucher' })
    },
    goProd () {
      this.$router.push({ name: 'HomePointProd' })
    }
  }
}
</script>

<style scoped lang="scss">
    .font-size-activity-tag {font-size:$h6!important;}
    .color-tip { color: #909399!important; }
    .color-base-text {color: #ff4544!important;}
    .goods-list.double-column {display: flex;-webkit-flex-wrap: wrap;flex-wrap: wrap;margin-top: 10px}
    .goods-list.double-column .goods-item{-webkit-box-flex: 1;-webkit-flex: 1;flex: 1;-webkit-flex-basis: 48%;flex-basis: 48%;max-width: calc((100% - 15px) / 2);margin-right:15px;margin-bottom: 10px}
    .goods-list.double-column .goods-item:nth-child(2n) {margin-right: 0}

    .img-content >img{width: 100%;height: 100%;}
    .tips-layer .head {position: relative;}
    .tips-layer .title {height: 40px;line-height: 40px;text-align: center;font-size:$h2;font-weight: 700;}
    .tips-layer .iconclose{position: absolute;top: 4px;right: 22px;font-size:$h2;font-weight: 500;}
    .tips-layer .body .detail {padding: 10px;}
    .tips-layer .body .detail .font-size-base {margin-bottom: 5px;}
    .main-content{font-size:$subFontSize;line-height: 1.8;}
    .font-size-tag {font-size:$fontSize!important;}
    .color-base-bg {background-color: #ff4544!important;}
    .body-wrap {margin-top: 25px}
    .body-wrap.no-login {margin-top: 10px}
    .body-wrap .point-exchange-wrap {padding: 0 15px;margin-top: 15px}
    .body-wrap .type-wrap {display: flex;align-items: center}
    .body-wrap .type-wrap .type-name {font-size:$h2;color: #303133;line-height: 1}
    .body-wrap .type-wrap .view-content {width: 1px;height: 11px;background-color: #909399;margin: 0 10px}
    .body-wrap .type-wrap .type-sub {font-size:$fontSize;color: #909399;line-height: 1}
    .body-wrap .type-wrap .content{flex:1;display: flex;align-items: center}
    .body-wrap .list-wrap {width: 100%}
    .body-wrap .list-wrap .list-wrap-item {display: inline-block;margin-top: 10px;width:50%;}
    .body-wrap .list-wrap .list-wrap-item:nth-child(2n+2) {text-align: right}
</style>
